import { compose } from '@ngrx/store';
import { curry } from 'lodash';

export function createLink(callback) {
  const link = document.createElement('a');
  document.body.appendChild(link);
  callback(link);
  document.body.removeChild(link);
}

const download = curry(function (filename, data, link) {
  link.download = filename;
  link.href = window.URL.createObjectURL(data);
  link.click();
});

export const exportFile = (fileName = 'file') => compose(createLink, download(fileName));
